import React from 'react';
import useDimension, { DIMENSION } from '../../utils/dimension';
import { Routes, Route } from "react-router-dom";
import WelcomePageMobile from './Pages/WelcomePageMobile/WelcomePageMobile';
import LoginPageDesktop from './Pages/LoginPage/LoginPageDesktop';
import LoginPageMobile from './Pages/LoginPage/LoginPageMobile';
import SignUpPageDesktop from './Pages/SignUpPage/SignUpPageDesktop';
import SignUpPageMobile from './Pages/SignUpPage/SignUpPageMobile';
import PasswordRecoveryPage from './Pages/PasswordRecoveryPage/PasswordRecoveryPage';

function Authorization() {
  const dimension = useDimension();

  if (dimension == DIMENSION.MOBILE) {
    return (
      <Routes>
        <Route path={"/"} element={<WelcomePageMobile/>} />
        <Route path={"/login"} element={<LoginPageMobile/>} />
        <Route path={"/signup/*"} element={<SignUpPageMobile/>} />
        <Route path={"/recovery/*"} element={<PasswordRecoveryPage/>} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route path={"/"} element={<LoginPageDesktop/>} />
      <Route path={"/login"} element={<LoginPageDesktop/>} />
      <Route path={"/signup/*"} element={<SignUpPageDesktop/>} />
      <Route path={"/recovery/*"} element={<PasswordRecoveryPage/>} />
    </Routes>
  )
}

export default Authorization;
